import React from 'react';

import {ActionOrigin} from 'constants/AnalyticsConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {Grid, Storable} from 'constants/SampleConstants';
import {isFixedPlate} from 'samples/SampleUtil';
import * as StorableActions from 'samples/StorableActions';
import StorableToolbarContents from 'samples/toolbar/StorableToolbarContents';
import {ButtonStyle} from 'ui-library/buttons/Button';
import LegacyDropdownMenuItem from 'ui-library/dropdowns/LegacyDropdownMenuConstants';
import APIUtil from 'util/APIUtil';

interface Props {
  buttonStyle: ButtonStyle;
  storables: Array<Storable>;
  grid: Grid;
  selectedIds: Array<string>;
}

export default class GridCellToolbarContents extends React.Component<Props> {
  _handleExportGridToCSV = (): void => {
    StorableActions.exportGridToCSV(this.props.grid.id);
  };

  _getExportMenuItems(): Array<LegacyDropdownMenuItem> {
    const gridType = APIUtil.apiIdToType(this.props.grid.id);
    return [
      {
        name: `Export entire ${gridType} to CSV`,
        handleOnClick: this._handleExportGridToCSV,
        disabled: false,
      },
    ];
  }

  render(): JSX.Element {
    const gridIsFixedPlate = isFixedPlate(this.props.grid);
    const gridType = APIUtil.apiIdToType(this.props.grid.id);
    return (
      <StorableToolbarContents
        actionOrigin={
          gridType === ModelTypeConstants.PLATE
            ? ActionOrigin.INVENTORY_PLATE_PAGE_GRID_CELL_TOOLBAR
            : ActionOrigin.INVENTORY_BOX_PAGE_GRID_CELL_TOOLBAR
        }
        buttonStyle={this.props.buttonStyle}
        storables={this.props.storables}
        selectedIds={this.props.selectedIds}
        extraExportMenuItems={this._getExportMenuItems()}
        parentStorableForMove={this.props.grid}
        hideCheckInCheckOut={gridIsFixedPlate}
        hideMove={gridIsFixedPlate}
        hideArchive={gridIsFixedPlate}
      />
    );
  }
}
